export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const END_AJAX_CALL = 'END_AJAX_CALL';
export const LAYOUT_SIDEBAR = 'LAYOUT_SIDEBAR';
export const SET_CURRENT_USERS_TAB = 'SET_CURRENT_USERS_TAB';
export const SET_CURRENT_USER_EDIT_TAB = 'SET_CURRENT_USER_EDIT_TAB';
export const SET_CURRENT_BLOCKS_TAB = 'SET_CURRENT_BLOCKS_TAB';
export const SET_CURRENT_TRANSLATION_EDIT_TABS = 'SET_CURRENT_TRANSLATION_EDIT_TABS';
export const SET_CURRENT_CONFIGURATION_TAB = 'SET_CURRENT_CONFIGURATION_TAB';
export const SET_CURRENT_LABELS_TAB = 'SET_CURRENT_LABELS_TAB';
export const SET_CURRENT_STAFF_TAB = 'SET_CURRENT_STAFF_TAB';
export const SET_CURRENT_TAGS_TAB = 'SET_CURRENT_TAGS_TAB';
export const SET_CURRENT_FAQS_TAB = 'SET_CURRENT_FAQS_TAB';
export const SET_CURRENT_PAGES_TAB = 'SET_CURRENT_PAGES_TAB';
export const SET_CURRENT_TEMPLATES_TAB = 'SET_CURRENT_TEMPLATES_TAB';
export const SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS';


// WEBPACK FOOTER //
// ./src/containers/layout/types.js